<template>
  <div ref="chart" :style="{ width: chartWidth, height: chartHeight }"></div>
</template>

<script>
import * as echarts from "echarts";
import { listOfDaysMorUrl } from "@/api/bump";
export default {
  name: "EChart",
  props: {
    // options: {
    //   type: Object,
    //   required: true,
    // },
    chartWidth: {
      type: String,
      default: "100%",
    },
    chartHeight: {
      type: String,
      default: "200px",
    },
    listBumpMorn:{
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      chart: null,
      date:[],
    };
  },
  watch: {

  },
  mounted() {
    this.draw()
    //获取早出港航班颠簸时长
    this.listOfDaysMor()
    // console.log(this.listBumpMorn,'fvhbvhebgggggggggggui')
  },
  methods: {
    size() {
        setTimeout(() => {
          this.chart.resize()
        }, 500)
    },
    /***************获取早出港航班颠簸时长******************/
    async listOfDaysMor() {
      const param = {};
      param.days = 7;
      const result = await listOfDaysMorUrl(param);
      const data1 = [];
      const data2 = [];
      const data3 = [];
      const data4 = [];
      const data5 = [];
      const data6 = [];
      const datacity = [];
      if (result.code === "A00000") {
        if (result.data.length > 0) {
          const bump = result.data;
          let promises = bump.map(async (item) => {
            data1.push(item["mildTime"]);
            data2.push(item["mildModerateTime"]);
            data3.push(item["moderateTime"]);
            data4.push(item["severeTime"]);
            data5.push(item["thunderMildTime"]);
            data6.push(item["thunderSevereTime"]);
            datacity.push(item["etd"].substring(5).replace(/-/g, "."));
          });
          for (const promise of promises) {
            await promise;
          }
          this.listBumpMorn['mildTime']=data1
          this.listBumpMorn['mildModerateTime']=data2
          this.listBumpMorn['moderateTime']=data3
          this.listBumpMorn['severeTime']=data4
          this.listBumpMorn['thunderMildTime']=data5
          this.listBumpMorn['thunderSevereTime']=data6
          this.listBumpMorn['datacity']=datacity
          // console.log(this.listBumpMorn,'早出港颠簸数据')
          this.draw()
        }
      } else {
        this.$message.error(result.message);
        return false;
      }
    },


    //绘制图表数据
    draw() {
      const options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          orient: "horizontal",
          top: 22,
          right: "0%",
          bottom: "0%",
          itemWidth: 6,
          itemHeight: 6,
          itemGap: 8,
          textStyle: {
            color: "rgba(194, 217, 245, 0.85)",
            fontSize: 12
          },
          data: [
            "轻度",
            "轻中",
            "中度",
            "重度",
            "雷雨（轻）",
            "雷雨（重）"
          ],
        },

        grid: {
          left: "1%",
          right: "7%",
          bottom: "1%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              formatter: "{value}min",
              textStyle: {
                color: "rgba(194, 217, 245, 0.65)",
                fontSize: 12
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#1D3039",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(194, 217, 245, 0.65)",
                fontSize: 12
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(121,121,121,0.1)",
              },
            },
            data: this.listBumpMorn['datacity'],
          },
        ],
        series: [
          {
            name: "轻度",
            type: "bar",
            stack: "1",
            barWidth: 6.5,
            data: this.listBumpMorn['mildTime'],
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: "#8EBF86",
              },
            },
          },
          {
            name: "轻中",
            type: "bar",
            stack: "1",
            data: this.listBumpMorn['mildModerateTime'],
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: "#EDDA79",
              },
            },
          },
          {
            name: "中度",
            type: "bar",
            stack: "1",
            data: this.listBumpMorn['moderateTime'],
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: "#EBA967",
              },
            },
          },
          {
            name: "重度",
            type: "bar",
            stack: "1",
            data: this.listBumpMorn['severeTime'],
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: "#E07073",
              },
            },
          },
          {
            name: "雷雨（轻）",
            type: "bar",
            barWidth: 6.5,
            stack: "2",
            data: this.listBumpMorn['thunderMildTime'],
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: "#7ACCB8",
              },
            },
          },
          {
            name: "雷雨（重）",
            type: "bar",
            stack: "2",
            data:  this.listBumpMorn['thunderSevereTime'],
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: "#FF8097",
              },
            },
          },
        ],
      };

      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(options);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/largescreen/components/echarts3.vue